import { NgModule } from '@angular/core';
import { RouterModule, UrlMatchResult, UrlSegment } from '@angular/router';
import { HomeComponent } from '../app-home/home.component';
import { RouterGuardService } from '../services/router-guard.service';
// import { StaticPagesComponent } from '../static-pages/static-pages.component';
import { AppCustomPreloader } from '../custom-preloader';
import { GamingwindowComponent } from '../gaming/gamingwindow/gamingwindow.component';
import { LobbyGameGroupComponent } from '../lobby/lobby-game-group/lobby-game-group.component';
import { DisableDesktopRouteGuardService } from '../services/disable-desktop-route-guard.service';
import { PagenotfoundComponent } from '../app-myaccount/pagenotfound/pagenotfound.component';
import { DummyRegisterPageComponent } from '../dummy-register-page/dummy-register-page.component';
import { StaticPagesComponent } from '../static-pages/static-pages.component';
import { MobileGuard } from '../services/mobile.guard';
import { ValidRouteGuardService } from '../services/valid-route.guard.service';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: ':id',
        component: HomeComponent,
        children:[
          {path:'register', component:DummyRegisterPageComponent, canActivate: [RouterGuardService, DisableDesktopRouteGuardService]}
        ],
        data:{
          homePage:true,
          title: 'seo.homePageMetaTitle',
          keywords: 'seo.homePageMetaKeyWords',
          description: 'seo.homePageMetaDescription'
        }
      
      },
      //if need this feature again, refer ESI-1032 PR
      //old registration routing page for mobile 
      // {
      //   path: ':id/register',
      //   loadChildren: () => import('../app-registration/registration.module').then(m => m.RegistrationModule),
      //   canActivate: [RouterGuardService, DisableDesktopRouteGuardService],
      //   data: {
      //     title: 'seo.registerMetaTitle',
      //     keywords: 'seo.registerMetaKeyWords',
      //     description: 'seo.registerMetaDescription'
      //   }
      // },
      // {
      //   path: ':id/mob_register',
      //   loadChildren: () => import('../app-registration/registration.module').then(m => m.RegistrationModule),
      //   canActivate: [RouterGuardService],
      //   data: {
      //     title: 'seo.registerMetaTitle',
      //     keywords: 'seo.registerMetaKeyWords',
      //     description: 'seo.registerMetaDescription'
      //   }
      // },
      {
        path:":id/promotions",
        loadChildren: () => import('../promotions/promotion.module').then(m => m.PromotionModule),
        data: {
          title: 'seo.promotionsMetaTitle',
          keywords: 'seo.promotionsMetaKeyWords',
          description: 'seo.promotionsMetaDescription'
        },
       
      },
      {
        path:':id/login',
        loadChildren:() => import('../login-page/login.module').then(m => m.LoginModule)
      },
      {
        path:':id/myaccount',
        loadChildren:() => import('../app-myaccount/myaccount.module').then(m => m.MyAccountModule),
        data: { preload: true },
        canActivate: [MobileGuard]
      },
      // {
      //   path:':id/accountstatus',
      //   loadChildren:() => import('../account-status/account-status.module').then(m => m.AccountstatusModule)
      // },
      {
        matcher: gamePageMatcher,
        component: GamingwindowComponent
      },
      {
        path: ':id/forgotpassword',
        loadChildren: () => import('../app-forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordModule)
      },
      {
        path: ':id/reset-password',
        loadChildren: () => import('../reset-password/resetpassword.module').then(m => m.ResetpasswordModule)
      },
      {
        path: ':id/page/:url',
        component: StaticPagesComponent,
        data:{'staticPage':true}
      },
      // {
      //   path: ':id/contact',
      //   loadChildren: () => import('../contact/contact.module').then(m => m.ContactModule)
      // },
      {
        path: ':id/casino',
        component: LobbyGameGroupComponent,
        data: {
          title: 'seo.allGamesMetaTitle',
          keywords: 'seo.allGamesMetaKeyWords',
          description: 'seo.allGamesMetaDescription'
        }
      },
      {
        path: ':id/casino/:gamegroup',
        component: LobbyGameGroupComponent,
        canActivate: [ValidRouteGuardService]
      },
      {
        path: ':id/casino/:gamegroup/:gamegrouptype',
        component: LobbyGameGroupComponent,
        canActivate: [ValidRouteGuardService]
      },
      {
        path: ':id/cashier/callback/:payment/:sessionid',
        redirectTo: ':id'
      },

      { path: '**', pathMatch: 'full', 
        component: PagenotfoundComponent 
      }
    ], { useHash: false, onSameUrlNavigation: 'reload', preloadingStrategy: AppCustomPreloader })
  ],
  exports: [RouterModule]
})

export class AppRouterModule { }

export function gamePageMatcher(url: UrlSegment[]) {
  if (url.length === 3) {
    const path = url[1].path;
    if (path ==='gameplay') {
      return {
        consumed: url,
        posParams: {
          gameId: new UrlSegment(url[2].path, {})
        }
      };
    }
  }

  return null;
}
